import React, { useEffect, useRef, useState } from "react";
import {
  getQueues,
} from "../utilities/genesysCloudUtils";
import "../App.css";
import { Loading } from "./Loading";
import { Queues } from "./Queues";
import { WrapupCodesTable } from "./WrapupCodesTable";

export function QueuesMain({
  activeTab,
  checkedDivisions,
  setPageCount,
  pageNumber,
  setPageNumber,
  setTabName,
  setOpts,
  opts,
  filters,
  setIsVisible,
  ...exportProps
}) {
  const [queues, setQueues] = useState([]);
  const [queueCache, setQueueCache] = useState({});
  const [enableLoading, setEnableLoading] = useState(true);
  const [loadingText] = useState("Fetching data...");
  const previousQueueQuery = useRef("");
  const [pageSize] = useState(
    activeTab === "Queues" ? 100 : activeTab === "Wrapup Codes Table" ? 25 : 100
  );

  useEffect(() => {
    const queryKey = JSON.stringify([checkedDivisions, filters.name, filters.id]);
    const queryChanged = previousQueueQuery.current && previousQueueQuery.current !== queryKey;
    previousQueueQuery.current = queryKey;

    if (queryChanged && pageNumber !== 1) {
      setPageNumber(1);
      return;
    }

    generateQueues(queryChanged);
  }, [pageNumber, activeTab, checkedDivisions, filters.name, filters.id]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const tabName = activeTab === "Wrapup Codes Table" ? "wrapup-table-tab" : "queues-tab";
    const showFilters = tabName === "queues-tab";

    setTabName(tabName);
    setOpts({ name: "", id: "" })
    setIsVisible({ divisions: showFilters, object: showFilters, applyButton: showFilters })
  }, [activeTab]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setEnableLoading(true);
    setPageNumber(1);
  }, [checkedDivisions, filters.name, filters.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const generateQueues = (resetPage = false) => {
    const currentPage = resetPage ? 1 : pageNumber;

    if (resetPage && pageNumber !== 1) {
      setPageNumber(1);
    }

    let opts = {
      pageSize: pageSize, // Number | Page size
      pageNumber: currentPage,
      id: [], // [String] | Include only queues with the specified ID(s)
      sortOrder: "ASC", // String | Ascending or descending sort order
      divisionId: checkedDivisions, // [String] | Include only queues in the specified division ID(s)
    };

    if (filters.name && filters.name.length > 0) {
    }

    if (filters.id && filters.id.length > 0) {
      opts.id.push(filters.id);
    }

    getQueues(opts).then((data) => {
      setQueues(data.entities.sort((a, b) => a.name.localeCompare(b.name)));
      setPageCount(data.pageCount);
      setEnableLoading(false);
    });
  };

  return (
    <>
      {enableLoading && queues ? (
        <Loading loadingText={loadingText} />
      ) : (
        <>
          {activeTab === "Queues" ? (
            <Queues
              queues={queues}
              pageNumber={pageNumber}
              activeTab={activeTab}
              queueCache={queueCache}
              setQueueCache={setQueueCache}
              {...exportProps}
            />
          ) : (
            <>
              {/* <Pagination
                pageCount={pageCount}
                pageNumber={pageNumber}
                onPageChange={onPageChange}
              /> */}
              <WrapupCodesTable
                queues={queues}
                queueCache={queueCache}
                setQueueCache={setQueueCache}
                {...exportProps}
              />
            </>
          )}
        </>
      )}
    </>
  );
}
